/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-05-26 17:09:28
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-09-01 16:40:40
 * @FilePath: \crm-product\src\views\performanceCalculation\views\result_statement\annual_terminal_performance_report\table\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import TablePage from '@/found/components/table_page';
import Form from '../form/detail.vue';
import ViewTaskForm from '../viewTask/detail.vue';
import ViewAgreementForm from '../viewAgreement/detail.vue';
import ViewExcuteRecordForm from '../viewExcuteRecord/detail.vue';
import ViewRewardForm from '../viewReward/detail.vue';

export default {
  extends: TablePage,
  components: {
    Form,
    ViewTaskForm,
    ViewAgreementForm,
    ViewExcuteRecordForm,
    ViewRewardForm,
  },
  name: 'DirectInvestmentEventTable',
  data() {
    return {

    };
  },
  created() {
    this.getConfigList('main-list');
  },

  methods: {
    afterGetList() {
      this.tableData = this.tableData.map((item) => ({
        ...item,
        activityTime: `${item.beginDate} - ${item.endDate}`,
      }));
    },
    // 控制按钮显示
    clickVisible({
      row,
      val: {
        code,
      },
    }) {
      const {
        activityStatus,
      } = row;
      if (code === 'activity_settle' && ['cancel', 'closed'].includes(activityStatus)) {
        return false;
      }
      return true;
    },
    modalClick({
      val,
      row,
    }) {
      if (val.code === 'activity_settle') {
        this.formConfig = {
          id: row.id,
          disabled: ['settled', 'settling'].includes(row.activityStatus),
        };
        this.modalConfig.title = '活动结算';
        this.openFull();
      } else if (val.code === 'view_task') {
        this.formConfig = {
          actDetailCode: row.actDetailCode,
        };
        this.formName = 'ViewTaskForm';
        this.modalConfig.title = '查看任务';
        this.openFull();
      } else if (val.code === 'view_agreement') {
        this.formConfig = {
          actDetailCode: row.actDetailCode,
        };
        this.formName = 'ViewAgreementForm';
        this.modalConfig.title = '查看协议';
        this.openFull();
      } else if (val.code === 'view_excute_record') {
        this.formConfig = {
          actDetailCode: row.actDetailCode,
        };
        this.formName = 'ViewExcuteRecordForm';
        this.modalConfig.title = '查看执行记录';
        this.openFull();
      } else if (val.code === 'view_reward') {
        this.formConfig = {
          actDetailCode: row.actDetailCode,
        };
        this.formName = 'ViewRewardForm';
        this.modalConfig.title = '查看奖励';
        this.openFull();
      } else if (val.code === 'settle_report') {
        // todo 生成结算报告
      }
    },
  },
};
